"use client";

import Box from "@sendsprint/ui-react/components/box";
import Typography from "@sendsprint/ui-react/components/typography";
import React from "react";

interface Props {
  blogsRefetch: (requestTag?: string | undefined) => Promise<void>;
  cacheTag: string;
  label: string;
}

const BlogError = ({ blogsRefetch, cacheTag, label }: Props) => {
  return (
    <Box className="ss:flex ss:flex-col ss:items-center ss:gap-5 ss:py-20">
      <Typography as="h3" variant="h4">
        {label}
      </Typography>
      <button
        data-testid="blogs-list-retry-btn"
        onClick={() => blogsRefetch(cacheTag)}
        className="ss:px-5 ss:py-2 ss:underline ss:text-[20px] ss:focus:focus-ring ss:rounded-lg"
      >
        Retry
      </button>
    </Box>
  );
};

export default BlogError;
